import { useMemo } from 'react';
import app from '../../../../../../../firebase';

export default function useStorageRef(props) {
    const { bucket } = props || {};
    return useMemo(() => app.storage(bucket).ref(), [app, bucket]);
}
